import React from 'react'
import { Heading, HeadingProps } from '@chakra-ui/react'

function H1({ size, ...rest }: HeadingProps) {
  return <Heading as='h1' size={size ?? { base: '4xl', md: '5xl', xl: '6xl' }} {...rest} />
}

function H2({ size, ...rest }: HeadingProps) {
  return <Heading as='h2' size={size ?? { base: '3xl', md: '4xl', xl: '5xl' }} {...rest} />
}

function H3({ size, ...rest }: HeadingProps) {
  return <Heading as='h3' size={size ?? { base: '2xl', md: '3xl', xl: '4xl' }} {...rest} />
}

function H4({ size, ...rest }: HeadingProps) {
  return <Heading as='h4' size={size ?? { base: 'xl', xl: '2xl' }} {...rest} />
}

function H5({ size, ...rest }: HeadingProps) {
  return <Heading as='h5' size={size ?? { base: 'md', xl: 'xl' }} {...rest} />
}

function H6({ size, ...rest }: HeadingProps) {
  return <Heading as='h6' size={size ?? { base: 'sm', xl: 'md' }} {...rest} />
}

export { H1, H2, H3, H4, H5, H6 }
